"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverSurface: function() {
        return _TeachingPopoverSurface.TeachingPopoverSurface;
    },
    renderTeachingPopoverSurface_unstable: function() {
        return _renderTeachingPopoverSurface.renderTeachingPopoverSurface_unstable;
    },
    teachingPopoverSurfaceClassNames: function() {
        return _useTeachingPopoverSurfaceStylesstyles.teachingPopoverSurfaceClassNames;
    },
    useTeachingPopoverSurfaceStyles_unstable: function() {
        return _useTeachingPopoverSurfaceStylesstyles.useTeachingPopoverSurfaceStyles_unstable;
    },
    useTeachingPopoverSurface_unstable: function() {
        return _useTeachingPopoverSurface.useTeachingPopoverSurface_unstable;
    }
});
const _TeachingPopoverSurface = require("./TeachingPopoverSurface");
const _renderTeachingPopoverSurface = require("./renderTeachingPopoverSurface");
const _useTeachingPopoverSurface = require("./useTeachingPopoverSurface");
const _useTeachingPopoverSurfaceStylesstyles = require("./useTeachingPopoverSurfaceStyles.styles");
